// extracted by mini-css-extract-plugin
module.exports = {"HeadingContainer":"Header_HeadingContainer__1H20z","HeadingContainer__text":"Header_HeadingContainer__text__3OZ-k"};